module.exports = __webpack_public_path__ + "img/defailt-avatar.81bfb028.png";